const _temp0 = require("../../intl/breadcrumbs/ar-AE.json");
const _temp1 = require("../../intl/breadcrumbs/bg-BG.json");
const _temp2 = require("../../intl/breadcrumbs/cs-CZ.json");
const _temp3 = require("../../intl/breadcrumbs/da-DK.json");
const _temp4 = require("../../intl/breadcrumbs/de-DE.json");
const _temp5 = require("../../intl/breadcrumbs/el-GR.json");
const _temp6 = require("../../intl/breadcrumbs/en-US.json");
const _temp7 = require("../../intl/breadcrumbs/es-ES.json");
const _temp8 = require("../../intl/breadcrumbs/et-EE.json");
const _temp9 = require("../../intl/breadcrumbs/fi-FI.json");
const _temp10 = require("../../intl/breadcrumbs/fr-FR.json");
const _temp11 = require("../../intl/breadcrumbs/he-IL.json");
const _temp12 = require("../../intl/breadcrumbs/hr-HR.json");
const _temp13 = require("../../intl/breadcrumbs/hu-HU.json");
const _temp14 = require("../../intl/breadcrumbs/it-IT.json");
const _temp15 = require("../../intl/breadcrumbs/ja-JP.json");
const _temp16 = require("../../intl/breadcrumbs/ko-KR.json");
const _temp17 = require("../../intl/breadcrumbs/lt-LT.json");
const _temp18 = require("../../intl/breadcrumbs/lv-LV.json");
const _temp19 = require("../../intl/breadcrumbs/nb-NO.json");
const _temp20 = require("../../intl/breadcrumbs/nl-NL.json");
const _temp21 = require("../../intl/breadcrumbs/pl-PL.json");
const _temp22 = require("../../intl/breadcrumbs/pt-BR.json");
const _temp23 = require("../../intl/breadcrumbs/pt-PT.json");
const _temp24 = require("../../intl/breadcrumbs/ro-RO.json");
const _temp25 = require("../../intl/breadcrumbs/ru-RU.json");
const _temp26 = require("../../intl/breadcrumbs/sk-SK.json");
const _temp27 = require("../../intl/breadcrumbs/sl-SI.json");
const _temp28 = require("../../intl/breadcrumbs/sr-SP.json");
const _temp29 = require("../../intl/breadcrumbs/sv-SE.json");
const _temp30 = require("../../intl/breadcrumbs/tr-TR.json");
const _temp31 = require("../../intl/breadcrumbs/uk-UA.json");
const _temp32 = require("../../intl/breadcrumbs/zh-CN.json");
const _temp33 = require("../../intl/breadcrumbs/zh-TW.json");
module.exports = {
  "ar-AE": _temp0,
  "bg-BG": _temp1,
  "cs-CZ": _temp2,
  "da-DK": _temp3,
  "de-DE": _temp4,
  "el-GR": _temp5,
  "en-US": _temp6,
  "es-ES": _temp7,
  "et-EE": _temp8,
  "fi-FI": _temp9,
  "fr-FR": _temp10,
  "he-IL": _temp11,
  "hr-HR": _temp12,
  "hu-HU": _temp13,
  "it-IT": _temp14,
  "ja-JP": _temp15,
  "ko-KR": _temp16,
  "lt-LT": _temp17,
  "lv-LV": _temp18,
  "nb-NO": _temp19,
  "nl-NL": _temp20,
  "pl-PL": _temp21,
  "pt-BR": _temp22,
  "pt-PT": _temp23,
  "ro-RO": _temp24,
  "ru-RU": _temp25,
  "sk-SK": _temp26,
  "sl-SI": _temp27,
  "sr-SP": _temp28,
  "sv-SE": _temp29,
  "tr-TR": _temp30,
  "uk-UA": _temp31,
  "zh-CN": _temp32,
  "zh-TW": _temp33
}